































































import Component from "vue-class-component";
import { BaseRootPageComponent } from "@/components/BaseRootPageComponent";

import CoreAPI from "@/utils/core-api";
import * as modals from "@/utils/modals";
import LoadingIndicator from "@/components/LoadingIndicator.vue";

@Component({
  components: {
    LoadingIndicator
  }
})
export default class Connections extends BaseRootPageComponent {
  loading = true;
  search = "";
  connections: any[] = [];
  timeout?: number;

  get displayedItems() {
    return (
      this.connections
        .filter(
          c =>
            c.serial.indexOf(this.search) !== -1 ||
            c.ip.indexOf(this.search) !== -1 ||
            c.model.indexOf(this.search) !== -1
        )
        // Sort by established date descending
        .sort((a, b) => new Date(b.established).getDate() - new Date(a.established).getDate())
    );
  }

  async created() {
    this.setTitle("Connections");
    await this.fetchConnections();
  }

  beforeDestroy() {
    clearInterval(this.timeout);
  }

  async fetchConnections() {
    try {
      this.connections = await CoreAPI.getConnections();

      // This keeps loading the connections every 1 second as long as there hasn't been an error. If there's an error,
      // stop loading because the error probably hasn't gone away in 1 second
      //
      // This is here instead of using an interval because if the server is unreachable, it may take a few seconds for
      // the request to complete, in which case this method would have been called multiple times and would have opened
      // multiple error modals.
      this.timeout = setTimeout(() => this.fetchConnections(), 1000);
    } catch (error) {
      this.connections = [];
      this.search = "";

      if ((error as any).isNetworkError) {
        await modals.showLostConnectionModal(this.$bvModal);
      } else {
        await modals.showUnexpectedErrorModal(this.$bvModal);
      }
    } finally {
      this.loading = false;
    }
  }

  goToConnection(serial: string) {
    this.$router.push({ name: "Connection", params: { serial } });
  }
}
